<div
  ngbDropdown
  placement="bottom-end"
  role="sort"
  class="text-gray-700">
  <div
    ngbDropdownToggle
    role="button">Sort By: <strong>{{ sort.label }}</strong></div>
  <ul
    ngbDropdownMenu
    class="dropdown-menu dropdown-menu-end shadow-sm">
    @for (option of options; track option) {
      <li
        ngbDropdownItem
        role="button"
        tabindex="0"
        (keyup.enter)="setSort(option.key)"
        (click)="setSort(option.key)">{{ option.value }}
      </li>
    }
  </ul>
</div>
